import { isNumber } from 'lodash';
import React, { FC, useMemo } from 'react';

interface ChessMatchTypeFormatProps {
  limit: number;
  increment: number;
}

export const ChessMatchTypeFormat: FC<ChessMatchTypeFormatProps> = ({
  increment = 0,
  limit = 0,
}) => {
  const mLimit = useMemo(() => Math.floor(limit / 60), [limit]);

  const matchType = useMemo(() => {
    switch (true) {
      case mLimit < 3:
        return 'Bullet';
      case mLimit <= 5:
        return 'Blitz';
      case mLimit <= 15:
        return 'Rapid';
      case mLimit > 16:
      default:
        return 'Classical';
    }
  }, [mLimit]);

  if (!isNumber(increment) || !isNumber(limit)) {
    return null;
  }

  return <>{`${mLimit}+${increment} ${matchType}`}</>;
};
